import Model from 'mewe/utils/store-utils/model/model';
import { attr } from 'mewe/utils/store-utils/model/attribute';
import { computed } from '@ember/object';

const questsWithProgress = [
  'Join5Groups',
  'Follow3Pages',
  'StayActiveFor2Days',
  'StayActiveFor3Days',
  'Invite3Friends',
  'Follow3Users',
  'Get10ReactionsUnderPostsOrComments',
  'Get5CommentsUnderPosts',
  'Get5Followers',
];

const model = Model.extend({
  questId: attr('string'), // BE bug to be fixed in next update
  title: attr('string'),
  description: attr('string'),
  completed: attr('boolean'),
  completedAt: attr('string'),
  progress: attr('number'),
  total: attr('number'),
  hintSeen: attr('boolean'),

  progressPct: computed('progress', function () {
    if (questsWithProgress.includes(this.get('questId'))) {
      const progress = (this.get('progress') / this.get('total')) || 0;
      return Math.round(progress * 100);
    }
    return null;
  }),
  progressText: computed('progress', function () {
    if (questsWithProgress.includes(this.get('questId'))) {
      return `${this.get('progress')} / ${this.get('total')}`;
    }
    return null;
  }),
});

export default model;
